/*
 * File per la definizione dei Service Angular, ovvero oggetti che espongono funzionalita' condivise tra diversi Controller:
 * https://code.angularjs.org/1.5.8/docs/guide/services
 */
define([
    'angular'
],
    function (angular) {

        var messageServices = angular.module('messageServices', []);

        messageServices.service('MessageService', ['$rootScope', '$log', 'CONSTANTS', MessageService]);

        /*
         * Service per visualizzare i messaggi di notifica nelle pagine.
         * I metodi per aggiungere i messaggi accettano un Array di stringhe o di oggetti.
         * Gli oggetti devono avere la struttura definita in messages.json
         */
        function MessageService($rootScope, $log, CONSTANTS) {
            /*
             * Variabili private
             */
            var _securityMessages = [];
            var _errorMessages = [];
            var _infoMessages = [];
            var _successMessages = [];
            var _systemMessages = [];
            var _warningMessages = [];

            var _constants = {
                SUCCESS: "SUCCESS",
                INFO: "INFO",
                WARNING: "WARNING",
                ERROR: "ERROR",
                SYSTEM: "SYSTEM",
                SECURITY: "SECURITY"
            };

            /*
             * Flag privato per indicare se i messaggi precedenti sono stati gia' visualizzati
             */
            var _isShown = false;

            /*
             * Metodo privato per rimuovere tutti i messaggi
             */
            var _clearMessages = function () {
                _securityMessages = [];
                _errorMessages = [];
                _infoMessages = [];
                _successMessages = [];
                _systemMessages = [];
                _warningMessages = [];

                _isShown = false;
            };
            //LM
            var _singleMessage = function (type, message, id) {
                _clearMessages();
                _addMessage(type, message, id);
            };

            var _setMessages = function (remoteMessages) {
                // impostiamo i messaggi resettiamo quelli vecchi
                _clearMessages();

                if (remoteMessages !== undefined && remoteMessages !== null) {
                    for (var i in remoteMessages) {

                        var item = remoteMessages[i];
                        var severity = item.severity;

                        var list = undefined;
                        switch (severity) {
                            case 'SECURITY':
                                list = _securityMessages;
                                break;
                            case 'SYSTEM':
                                list = _systemMessages;
                                break;
                            case 'ERROR':
                                list = _errorMessages;
                                break;
                            case 'WARNING':
                                list = _warningMessages;
                                break;
                            case 'INFO':
                                list = _infoMessages;
                                break;
                            case 'SUCCESS':
                                list = _successMessages;
                                break;
                        }

                        _addMessage(list, item);
                    }
                }
            }

            var _addMessage = function (messageArray, item, id) {
                if (item.message !== undefined && item.message !== null && messageArray != undefined) {
                    messageArray.push(item);
                    $log.debug("messaggio aggiunto applicativamente: ");
                    $log.debug(item);
                    $log.debug(messageArray.length);
                }
            };

            this.hasMessage = function (msg) {
                if (_messages !== undefined && _messages !== null && msg !== undefined && msg !== '') {
                    for (var int = 0; int < _messages.length; int++) {
                        if (_messages[int].message === msg) {
                            return true;
                        };
                    }
                    return false;
                }
            };

            this.setMessages = function (remoteMessages) {
                _setMessages(remoteMessages);
            };

            this.singleMessageInfo = function (message, id) {
                var type = 'info';
                _singleMessage(type, message, id);
            };
            this.singleMessageWarnings = function (message, id) {
                var type = 'warnings';
                _singleMessage(type, message, id);
            };
            this.singleMessageErrors = function (message, id) {
                var type = 'errors';
                _singleMessage(type, message, id);
            };

            //AGS

            /*
             * Metodo pubblico per aggiungere i messaggi di errore
             * @param messages - 
             */
            this.addErrorMessages = function (messages) {
                if (_isShown)
                    _clearMessages();

                for (var i in messages) {
                    if (typeof messages[i] === 'object') {
                        _errorMessages.push(messages[i]);
                    } else {
                        _errorMessages.push({
                            'text': messages[i]
                        });
                    }
                }
            };
            //
            //        /*
            //		 * Metodo pubblico per aggiungere i messaggi informativi
            //		 */
            this.addInfoMessages = function (messages) {
                if (_isShown)
                    _clearMessages();

                for (var i in messages) {
                    if (typeof messages[i] === 'object') {
                        _infoMessages.push(messages[i]);
                    } else {
                        _infoMessages.push({
                            'text': messages[i]
                        });
                    }
                }
            };

            /*
             * Metodo pubblico per aggiungere i messaggi di successo
             */
            this.addSuccessMessages = function (messages) {
                if (_isShown)
                    _clearMessages();

                for (var i in messages) {
                    if (typeof messages[i] === 'object') {
                        _successMessages.push(messages[i]);
                    } else {
                        _successMessages.push({
                            'text': messages[i]
                        });
                    }
                }
            };

            /*
             * Metodo pubblico per aggiungere i messaggi di errore di sistema
             */
            this.addSystemMessages = function (messages) {
                if (_isShown)
                    _clearMessages();

                for (var i in messages) {
                    if (typeof messages[i] === 'object') {
                        _systemMessages.push(messages[i]);
                    } else {
                        _systemMessages.push({
                            'message': messages[i]
                        });
                    }
                }
            };

            /*
             * Metodo pubblico per aggiungere i messaggi di avvertimento
             */
            //		this.addWarningMessages = function(messages) {
            //			if (_isShown)
            //				_clearMessages();
            //
            //			for (var i in messages) {
            //				if (typeof messages[i] === 'object') {
            //					_warningMessages.push(messages[i]);
            //				} else {
            //					_warningMessages.push({
            //						'text' : messages[i]
            //					});
            //				}
            //			}
            //		};

            /*
             * Metodo pubblico per visualizzare i messaggi nella pagina
             */
            this.showMessages = function () {
                /*
                 * Emetto l'evento per notificare l'aggiunta di nuovi messaggi.
                 * L'evento verra' intercettato dal MessageCtrl
                 */
                $rootScope.$broadcast('messagesUpdate');

                _isShown = true;
            };

            /*
             * Metodo pubblico per ottenere tutti i messaggi
             */
            this.getAllMessages = function () {
                var _messages = {};

                if (_successMessages.length > 0)
                    _messages[_constants.SUCCESS] = _successMessages;
                if (_infoMessages.length > 0)
                    _messages[_constants.INFO] = _infoMessages;
                if (_warningMessages.length > 0)
                    _messages[_constants.WARNING] = _warningMessages;
                if (_errorMessages.length > 0)
                    _messages[_constants.ERROR] = _errorMessages;
                if (_systemMessages.length > 0)
                    _messages[_constants.SYSTEM] = _systemMessages;
                if (_securityMessages.length > 0)
                    _messages[_constants.SECURITY] = _securityMessages;

                return _messages;
            };

            /*
             * Metodo pubblico per verificare la presenza di messaggi di tipo SYSTEM
             */
            this.hasSystemError = function () {
                return _systemMessages.length > 0;
            };

            this.hasError = function () {
                return _errorMessages.length > 0;
            };

            this.hasSecurityError = function () {
                return _securityMessages.length > 0;
            };

            this.hasAnyError = function () {
                return this.hasSystemError() || this.hasSecurityError() || this.hasError();
            };

            /*
             * Metodo pubblico per rimuovere tutti i messaggi
             */
            this.clearMessages = function () {
                /*
                 * Cancello eventuali messaggi precedenti
                 */
                _clearMessages();
                /*
                 * Emetto l'evento per notificare l'aggiornamento dei messaggi.
                 * L'evento verra' intercettato dal MessageCtrl
                 */
                $rootScope.$broadcast('messagesUpdate');
            };


            /**
             * Esegue il focus su un ID o sul div dei messaggi
             */
            this.focusId = function (id) {
                try {
                    var normalizedId = null;
                    if (id.indexOf('#') === 0) {
                        normalizedId = id.substring(1);
                    } else {
                        normalizedId = id;
                    }

                    //verifica esistenza di callapsible
                    try {
                        if (normalizedId) {
                            try {
                                var collElem = angular.element("[id$=" + normalizedId + "]");
                                if (collElem.length > 0) {
                                    //collElem.collapse('show');
                                    setTimeout(function () {
                                        //scroll angular
                                        var elem = "";
                                        try {
                                            elem = angular.element("[id$=" + normalizedId + "]");
                                        } catch (e) {
                                        }

                                        if (elem.length > 0) {
                                            elem.focus();
                                            if (normalizedId === CONSTANTS.MESSAGES_ID) {
                                                $window.scrollTo(0, 0);
                                            }
                                        }
                                    }, 200);

                                    //stop
                                    return;
                                }
                            } catch (e) {
                            }
                        }
                    } catch (e) {
                    }

                    //scroll angular
                    var elem = "";
                    try {
                        elem = angular.element("[id$=" + normalizedId + "]");
                    } catch (e) {
                    }

                    if (elem.length > 0) {
                        elem.focus();
                        if (normalizedId === CONSTANTS.MESSAGES_ID) {
                            $window.scrollTo(0, 0);
                        }
                    } else {
                        //broadcast ai vari controller per delegare un eventuale redirect.
                        $rootScope.$broadcast('redirect', id);
                    }
                } catch (e) {
                    $log.debug("Impossibile fare focus su id:" + id + " '" + e.message + "' ");
                }
            };
        };

        return messageServices;
    });


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/resources/js/app/services/message-services.js
// module id = 44
// module chunks = 1